type Props = {
  title: string;
  value: number | undefined | null;
  onChange: (value: number | null) => void;
};

export const WorkingHoursInput = ({ title, value, onChange }: Props) => {
  return (
    <>
      <label className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray">
        <span className="text-sm font-normal text-black">{title}</span>
        <div className="select-input-wrapper">
          <input
            className="select-input-working-hours text-sm px-1 mr-2"
            type="number"
            placeholder="時間を入力"
            min={0}
            value={value + ''}
            onChange={(e) => {
              onChange(e.target.value === '' ? null : Number(e.target.value));
            }}
          />
          時間以内
        </div>
      </label>

      <style jsx>{`
        .select-input-working-hours {
          max-width: 100px;
          -moz-appearance: textfield;
        }

        .select-input-working-hours::-webkit-outer-spin-button,
        .select-input-working-hours::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .select-input-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: space-between;
        }
      `}</style>
    </>
  );
};
